import React, { useState } from 'react';

export default function SectionBookmarkModal({ open, onClose, API_URL }) {
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  if (!open) return null;

  const handleCreate = async () => {
    const title = String(name || '').trim();
    if (!title) { setError('Please enter a section name.'); return; }
    setBusy(true); setError('');
    try {
      const token = localStorage.getItem('auth_token') || '';
      const res = await fetch(`${API_URL}/barcode/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ values: [`--${title}--`], shouldSave: false })
      });
      if (!res.ok) {
        const j = await res.json().catch(() => ({}));
        throw new Error(j.message || 'Failed to generate bookmark sheet');
      }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank', 'noopener');
      setTimeout(() => URL.revokeObjectURL(url), 30_000);
      onClose && onClose(true);
    } catch (e) {
      setError(e?.message || 'Failed to generate');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="upload-spinner-overlay" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="upload-spinner-box" style={{ width: 460, maxWidth: '95vw', textAlign: 'left' }}>
        <h3 style={{ marginTop: 0 }}>Section Bookmark Sheet</h3>
        <p style={{ marginTop: 0, color: 'var(--text)' }}>
          Enter a Section Name to generate a printable separator sheet with a bookmark barcode
          in the format <code>--BOOKMARK NAME--</code>.
        </p>
        <div style={{ marginTop: 8 }}>
          <label style={{ fontSize: 12 }}>Section Name</label>
          <input
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            autoFocus
            placeholder="e.g., Loan Documents"
            style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid var(--border-soft)', background: 'var(--input-bg)', color: 'var(--text)' }}
          />
        </div>
        {error && <div style={{ marginTop: 10, color: '#b71c1c' }}>{error}</div>}
        <div style={{ display: 'flex', gap: 8, marginTop: 12, justifyContent: 'flex-end' }}>
          <button className="btn btn-ghost" disabled={busy} onClick={() => onClose && onClose(false)}>Close</button>
          <button className="btn" disabled={busy} onClick={handleCreate}>{busy ? 'Generating…' : 'Generate & Print'}</button>
        </div>
      </div>
    </div>
  );
}

